<!-- 系统日志 -->
<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="Search">
        <div class="searchTxt">用户姓名</div>
        <el-input
          placeholder="请输入用户姓名"
          size="medium"
          v-model="queryLog.userName"
          @change="getReport()"
          clearable
        >
        </el-input>
      </div>

      <div class="Search1">
        <div class="searchTxt">操作时间</div>
        <el-date-picker
          @input="getReport()"
          v-model="Time"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          align="left"
        >
          <!-- value-format="yyyy-MM-dd HH:mm:ss" -->
        </el-date-picker>
      </div>
    </div>

    <!-- 卡片区域 -->
    <el-card class="right-card">
      <!-- 日志信息表格区域 -->
      <el-table
        :data="logList"
        :header-cell-style="{
          background: '#0395d9',
          color: '#505255',
          textAlign: 'center',
        }"
        :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
      >
        <el-table-column prop="logCreator" label="操作用户"> </el-table-column>
        <el-table-column prop="logCreatorType" label="日志来源">
          <template v-slot="logCreatorTypeSlot">
            <span v-if="logCreatorTypeSlot.row.logCreatorType == 1"
              >用户级</span
            >
            <span v-if="logCreatorTypeSlot.row.logCreatorType == 2"
              >系统级</span
            >
          </template>
        </el-table-column>
        <el-table-column prop="logContent" label="操作内容"> </el-table-column>
        <el-table-column prop="logCreateTime" label="操作时间">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryLog.page"
        :page-sizes="[15, 25, 35, 45, 55]"
        :page-size="queryLog.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 日志列表
      logList: [],
      // 总数量
      total: 0,
      // 查询日志信息
      queryLog: {
        // 开始时间
        btime: "",
        //结束时间
        etime: "",
        // 操作用户名
        userName: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 15,
      },

      // 时间选择器选择的开始和结束时间
      Time: "",
      // 时间选择器
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.getReport();
  },
  methods: {
    // 获取统计信息
    async getReport() {
      this.queryLog.btime = "";
      this.queryLog.etime = "";
      if (this.Time) {
        // 开始时间
        this.queryLog.btime = this.Time[0];
        // 结束时间
        this.queryLog.etime = this.Time[1];
      }

      const { data: res } = await this.$axios.get(
        `${this.$api}/log/search`,{
          params: this.queryLog
        }
       
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      if (res.data.rows) {
        this.logList = res.data.rows;
        this.total = res.data.total;
      }
    },

    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryLog.pageSize = size;
      this.getReport();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryLog.page = current;
      this.getReport();
    },
  },
};
</script>


<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

.box-card {
  height: 400px !important;
  overflow: auto;
  margin: 0;
}

// el-dialog高度自适应，内容超出时中间出现滚动条
.common-dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 0 auto !important;
    position: relative;
    .el-dialog__header {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      width: 100%;
      height: 60px;
      z-index: 1;
    }
    .el-dialog__body {
      width: 100%;
      overflow: hidden;
      overflow-y: auto;
      max-height: 90vh; //最大高度为视口高度的90%
      padding-top: 80px;
      padding-bottom: 100px;
      z-index: 1;
    }
    .el-dialog__footer {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 80px;
      z-index: 1;
    }
  }
}

.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;

  // 用户名搜索区域
  .Search {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 20px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 100px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
  .Search1 {
    width: 450px;
    display: flex;
    align-items: center;
    margin-left: 30px;
    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 80px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Main/Log/systemLog.vue